/**
 * @fileoverview POST handler for the "/apps/:app_group_id/custom_events_settings" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdCustomEventsSettingsCacheKeys } from "./constants";
import type {
  PostAppsAppGroupIdCustomEventsSettingsProps,
  AppsAppGroupIdCustomEventsSettingsResult,
} from "./types";

export const postAppsAppGroupIdCustomEventsSettings = reactQueryMutationAdapter(
  appsAppGroupIdCustomEventsSettingsCacheKeys,
  (props: PostAppsAppGroupIdCustomEventsSettingsProps): Promise<AppsAppGroupIdCustomEventsSettingsResult> => {
    const { appGroupId, ...request } = props;
    return fetch(`/apps/${appGroupId}/custom_events_settings`, "POST", request);
  }
);
